export default __webpack_public_path__ + "static/media/campaign_planning.ea62dc1b.svg";